import type { LegacyBudget, OverviewBudgetSummaryKeyValues, PublishStatus, ReviewBudgetStatus } from '@sysarb/sysarb-types/services/v1/pay-management';
import { getApiHost } from '@/appSettings';
import { RestManager } from '@/newApi/services/rest/RestManager';
import type { useResgate } from '@/login/composables/useResgate';
import { useLoginStore } from '@/login/stores/useLoginStore';

const payManagementService = new RestManager(`https://${getApiHost()}/pay-management-service`);

export function abort(): void {
    payManagementService.abort();
}

/**
 * Get Review by draft id
 *  @param reviewId Salary review id
 */
export async function getBudgetOverviewKeyValues(resgate: ReturnType<typeof useResgate>, reviewId: string): Promise<OverviewBudgetSummaryKeyValues | null> {
    const { instanceTopic } = useLoginStore();
    const promise = resgate.model<OverviewBudgetSummaryKeyValues>(`v1.pay-management.subdomain.${instanceTopic}.budget.${reviewId}.overviewkeyvalues`).then(res => {
        if (res?.success === false) return null;
        return res.data;
    });
    return promise;
}

/**
 * Get Review by draft id
 *  @param reviewId Salary review id
 */
export async function getBudgetStatus(resgate: ReturnType<typeof useResgate>, reviewId: string): Promise<ReviewBudgetStatus | null> {
    const { instanceTopic } = useLoginStore();
    const promise = resgate.model<ReviewBudgetStatus>(`v1.pay-management.subdomain.${instanceTopic}.budget.${reviewId}.budgetstatus`).then(res => {
        if (res?.success === false) return null;
        return res.data;
    });
    return promise;
}

/**
 * Fetch legacy budgets
 * @param reviewId Salary review id
 */
export async function getLegacyBudget(reviewId: string): Promise<LegacyBudget[]> {
    const { instance } = useLoginStore();
    return payManagementService.post<LegacyBudget[]>({}, `v1/${instance}/pay-management/budget/${reviewId}/legacybudget`);
}

/**
 * Delete legacy budget
 * @param legacyBudgetId Pay management review draft id
 */
export async function deleteLegacyBudget(resgate: ReturnType<typeof useResgate>, legacyBudgetId: string): Promise<unknown> {
    const promise = resgate.call<unknown>(`v1.pay-management.budget.${legacyBudgetId}`, 'deletelegacybudget', {}).then(res => {
        if (res?.success === false) return null;
        return res.data;
    });
    return promise;
}

/**
 * Get budget status
 * @param reviewId Review id
 */
export async function getBudgetPublishStatus(resgate: ReturnType<typeof useResgate>, reviewId: string): Promise<PublishStatus | null> {
    const promise = resgate.call<PublishStatus>(`v1.pay-management.budget.${reviewId}`, 'publishstatus', {}).then(res => {
        if (res?.success === false) return null;
        return res.data;
    });
    return promise;
}
